/* My Garden : du panier à la page de paiement du dashboard (pay.mygarden-fr.com, Monetico), même mécanique que les autres boutiques
   (Run Peak, Poké Maison). Le panier Shopify est transmis, la page de paiement s'ouvre avec son identifiant ; si la
   transmission échoue, on retombe sur le paiement Shopify. window.mgCheckout() part directement. */
(function () {
  var FALLBACK = '/checkout';
  var HANDOFF = 'https://pay.mygarden-fr.com/api/checkout/handoff';
  var busy = false;
  function isCheckoutControl(el) {
    if (!el) return false;
    if (el.name === 'checkout' || el.id === 'checkout' || el.id === 'CartDrawer-Checkout') return true;
    if (el.classList && el.classList.contains('cart__checkout-button')) return true;
    if (el.tagName === 'A') { var href = el.getAttribute('href') || ''; if (/^\/checkout(\b|\/|\?|$)/.test(href)) return true; }
    return false;
  }
  function withTimeout(p, ms) { return new Promise(function (ok, ko) { var t = setTimeout(function () { ko(new Error('timeout')); }, ms); p.then(function (v) { clearTimeout(t); ok(v); }, function (e) { clearTimeout(t); ko(e); }); }); }
  function handoff() {
    var shop = (window.Shopify && window.Shopify.shop) || location.hostname;
    return withTimeout(fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), 8000)
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; });
        if (!items.length) throw new Error('empty');
        return withTimeout(fetch(HANDOFF, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ shop: shop, cart_token: cart.token, items: items }), credentials: 'omit' }), 10000);
      })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || !j.url) throw new Error('bad'); window.location.href = j.url; });
  }
  function leave() { handoff().catch(function () { window.location.href = FALLBACK; }); }
  window.mgCheckout = function () { if (busy) return; busy = true; leave(); };
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button, input[type="submit"], a') : null;
    if (!isCheckoutControl(el)) return;
    e.preventDefault(); e.stopPropagation();
    if (busy) return; busy = true; if ('disabled' in el) el.disabled = true; leave();
  }, true);
  function strip(root) { var n = (root || document).querySelectorAll('.shopify-payment-button, .accelerated-checkout-block, [data-shopify="payment-button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart'); for (var i = 0; i < n.length; i++) n[i].remove(); }
  strip();
  if (window.MutationObserver) new MutationObserver(function () { strip(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
